import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { RoleEditForm } from "./components/RoleEditForm";

export function EditRolePage() {
  return (
    <LqsPage title="Edit Role">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <RoleEditForm />
      </Container>
    </LqsPage>
  );
}
